module.exports = __webpack_public_path__ + "static/media/payment-wait.841d8655.svg";